export const MeasurementTypeEnum = Object.freeze({
  None: 'none',
  Weight: 'weight',
  Dimension: 'dimension',
  Currency: 'currency',
});
